import { getPeriod } from "../../../period-selector/redux/selectors/PeriodSelectionSelectors";
import { getAllSelectedSubClassesByCategory } from "../../../product-selector/redux/selectors/MailClassesSelectors";
import { getAllSelectedTransportModesByLeg } from "../../../transport-mode-selector/redux/selectors/TransportModesSelectors";
import {
  getArrivalCheckedMailProcessingCenters,
  getDepartureCheckedMailProcessingCenters,
  getDepartureCheckedOperator,
  getArrivalCheckedOperator,
  getTrafficCheckedOperator,
} from "../../../target-node-impc-selector/redux/selectors/PostalOperatorSelectors";
import { getDepartureCheckedMailProcessingCenters as getDepartureCheckedMrdMailProcessingCenters } from "../../../target-node-mrd-impc-selector/redux/selectors/PostalOperatorSelectors";
import {
  getArrivalCheckedMailboxes,
  getDepartureCheckedMailboxes,
} from "../../../target-node-mailbox-selector/redux/selectors/PostalOperatorSelectors";
import {
  getArrivalCheckedUnlocodes,
  getDepartureCheckedUnlocodes,
} from "../../../target-node-unlocode-selector/redux/selectors/PostalOperatorSelectors";
import {
  getCheckedCarriers,
  getCheckedCarrierLabels,
} from "../../../target-node-carrier-selector/redux/selectors/CarrierSelectors";
import {
  getCheckedHandlers,
  getCheckedHandlerLabels,
} from "../../../target-node-handler-selector/redux/selectors/HandlerSelectors";
import DirectionTypes from "../../../../common/redux/actions/types/DirectionTypes";
import ReportDefinitions from "../../../../common/config/ReportDefinitions";
import scDefinitions from "../../../../common/config/SelectionCriteriaDefinitions";
import { getCurrentReportCode } from "../../../../user/redux/selectors/UserReportSelectors";
import { getReportCustomFilter } from "../../../../report/common/redux/selectors/ReportsSelectors";
import {
  getCheckedReports,
  getCheckedReportsLabels,
} from "../../../target-node-report-selector/redux/selectors/ReportsSelectors";
import { getCheckedOperatorUser } from "../../../target-node-operator-user-selector/redux/selectors/OperatorUserSelector";
import {
  getCheckedFilterOnItems,
  getCheckedOnlyShowItems,
  getCheckedOnlyShowItemsWith,
  getCheckedFilterOnImpc,
  getManualEntryText,
  getCheckedFilterOnDespatch,
  getSpaceSeparatedSuffixes,
} from "../../../target-node-item-criteria-selector/redux/selectors/ItemCriteriaSelector";

export const isDirectionsSwitched = (state) => {
  const report = ReportDefinitions[state.userData.currentReportCode];
  let switched = false;
  if (report) {
    report.selectionCriteria.items.some((sc) => {
      if (scDefinitions[sc].isDirectionsSwitched) {
        switched = scDefinitions[sc].isDirectionsSwitched(state);
        return true;
      }
      return false;
    });
  }
  return switched;
};
export const getSCRequestId = (state) =>
  state.selectionCriteriaWizard.requestId;

export const getDirection = (state) => {
  const report = ReportDefinitions[state.userData.currentReportCode];
  let direction = DirectionTypes.INBOUND;
  if (report) {
    // eslint-disable-next-line prefer-destructuring
    direction = report.reportDirections[0];
    report.selectionCriteria.items.some((sc) => {
      if (scDefinitions[sc].getDirections) {
        const directions = scDefinitions[sc].getDirections(state);
        if (isDirectionsSwitched(state)) {
          direction =
            directions.defaultDirection === DirectionTypes.INBOUND
              ? DirectionTypes.OUTBOUND
              : DirectionTypes.INBOUND;
        } else {
          direction = directions.defaultDirection;
        }
        return true;
      }
      return false;
    });
  }
  return direction;
};

export const getWizardValidationErrors = (state) => {
  const errorStack = [];
  const report = ReportDefinitions[state.userData.currentReportCode];
  if (report) {
    report.selectionCriteria.items.forEach((sc) => {
      if (sc !== "SC100" && sc !== "SC100_OVERVIEW") {
        scDefinitions[sc].validate(state, errorStack);
      }
    });
  }
  return errorStack;
};

export const getSelectedValues = (state) => {
  const report = ReportDefinitions[state.userData.currentReportCode];
  if (report) {
    return Object.assign(
      {},
      ...report.selectionCriteria.items.map((sc) => ({
        [sc]: scDefinitions[sc].getSelectedValue(state),
      }))
    );
  }
  return {};
};

export const getReporting = (state) => state.reporting;

export const getSelectionCriteria = (state) => ({
  period: getPeriod(state),
  direction: getDirection(state),
  reportCode: getCurrentReportCode(state),
  mailCategoriesWithSubClasses: getAllSelectedSubClassesByCategory(state),
  arrivalCheckedMailProcessingCenters:
    getArrivalCheckedMailProcessingCenters(state),
  departureCheckedMailProcessingCenters:
    getDepartureCheckedMailProcessingCenters(state),
  departureCheckedOperators: getDepartureCheckedOperator(state),
  departureCheckedMrdMailProcessingCenters:
    getDepartureCheckedMrdMailProcessingCenters(state),
  checkedCarriers: getCheckedCarriers(state),
  checkedCarrierLabels: getCheckedCarrierLabels(state),
  checkedHandlers: getCheckedHandlers(state),
  checkedHandlerLabels: getCheckedHandlerLabels(state),
  checkedReports: getCheckedReports(state),
  checkedReportsLabels: getCheckedReportsLabels(state),
  checkedOperatorUser: getCheckedOperatorUser(state),
  checkedFilterOnItems: getCheckedFilterOnItems(state),
  checkedOnlyShowItems: getCheckedOnlyShowItems(state),
  checkedOnlyShowItemsWith: getCheckedOnlyShowItemsWith(state),
  checkedFilterOnImpc: getCheckedFilterOnImpc(state),
  checkedFilterOnDespatch: getCheckedFilterOnDespatch(state),
  manualEntryText: getManualEntryText(state),
  spaceSeparatedSuffixes: getSpaceSeparatedSuffixes(state),
  arrivalCheckedMailboxes: getArrivalCheckedMailboxes(state),
  arrivalCheckedOperators: getArrivalCheckedOperator(state),
  departureCheckedMailboxes: getDepartureCheckedMailboxes(state),
  arrivalCheckedUnlocodes: getArrivalCheckedUnlocodes(state),
  departureCheckedUnlocodes: getDepartureCheckedUnlocodes(state),
  legsWithTransportModes: getAllSelectedTransportModesByLeg(state),
  customFilter: getReportCustomFilter(state),
  requestId: getSCRequestId(state),
  checkedTrafficOperators: getTrafficCheckedOperator(state),
});
